import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { IProps } from './models';
import { HiddenInput as Component } from './hidden-input';

export const HiddenInput = createWidget<unknown, IProps>()(Component);
